import { useState } from 'react';
import api from '../services/api';
import {
  LuShield, LuCheck, LuEye, LuEyeOff,
} from 'react-icons/lu';

const emptyForm = { currentPassword: '', newPassword: '', confirmPassword: '' };

function PasswordField({ label, value, onChange, placeholder, autoFocus }) {
  const [visible, setVisible] = useState(false);
  return (
    <div>
      <label className="form-label">{label}</label>
      <div style={{ position: 'relative' }}>
        <input
          className="form-control"
          style={{ paddingRight: 36 }}
          type={visible ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          autoFocus={autoFocus}
          autoComplete={label === 'Senha atual' ? 'current-password' : 'new-password'}
        />
        <button
          type="button"
          onClick={() => setVisible((v) => !v)}
          tabIndex={-1}
          style={{
            position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)',
            background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-3)', padding: 4,
          }}
        >
          {visible ? <LuEyeOff size={15} /> : <LuEye size={15} />}
        </button>
      </div>
    </div>
  );
}

export default function ChangePasswordPage({ forced = false, onSuccess }) {
  const [form,    setForm]    = useState(emptyForm);
  const [saving,  setSaving]  = useState(false);
  const [error,   setError]   = useState('');
  const [success, setSuccess] = useState('');

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const handleSave = async () => {
    setError('');
    setSuccess('');
    if (!form.currentPassword) { setError('Informe a senha atual.'); return; }
    if (form.newPassword.length < 8) { setError('A nova senha precisa ter pelo menos 8 caracteres.'); return; }
    if (form.newPassword !== form.confirmPassword) { setError('A confirmação não bate com a nova senha.'); return; }
    if (form.newPassword === form.currentPassword) { setError('A nova senha precisa ser diferente da atual.'); return; }

    setSaving(true);
    try {
      await api.put('/auth/change-password', {
        currentPassword: form.currentPassword,
        newPassword: form.newPassword,
      });
      setSuccess('Senha alterada com sucesso.');
      setForm(emptyForm);
      // No fluxo forçado (primeiro acesso / senha redefinida por admin), avisa
      // o App.js pra liberar a navegação normal — sem isso o usuário ficaria
      // preso nesta tela mesmo depois de trocar a senha com sucesso.
      if (onSuccess) onSuccess();
    } catch (e) {
      setError(e.response?.data?.error || 'Erro ao alterar a senha');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page-card">
      <div className="page-card-header">
        <div>
          <div className="page-card-title">Alterar Senha</div>
          <div className="page-card-subtitle">
            {forced ? 'Defina uma nova senha para continuar' : 'Troque a senha da sua conta'}
          </div>
        </div>
      </div>

      {forced && !success && (
        <div className="alert-custom warning" style={{ marginBottom: 16 }}>
          Por segurança, você precisa definir uma nova senha antes de continuar usando o sistema.
        </div>
      )}

      {error   && <div className="alert-custom danger"  style={{ marginBottom: 16 }}>{error}</div>}
      {success && <div className="alert-custom success" style={{ marginBottom: 16 }}>{success}</div>}

      <div style={{
        background: 'var(--surface-2)', border: '1px solid var(--border)', borderRadius: 10,
        padding: 24, maxWidth: 420, display: 'flex', flexDirection: 'column', gap: 14,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'var(--text-3)', fontSize: 12, marginBottom: 4 }}>
          <LuShield /> Por segurança, confirme a senha atual antes de definir uma nova.
        </div>

        <PasswordField
          label="Senha atual"
          value={form.currentPassword}
          onChange={set('currentPassword')}
          placeholder="••••••••"
          autoFocus
        />
        <PasswordField
          label="Nova senha"
          value={form.newPassword}
          onChange={set('newPassword')}
          placeholder="Mínimo 8 caracteres"
        />
        <PasswordField
          label="Confirmar nova senha"
          value={form.confirmPassword}
          onChange={set('confirmPassword')}
          placeholder="Repita a nova senha"
        />

        <button className="btn-salvar" onClick={handleSave} disabled={saving} style={{ marginTop: 4 }}>
          <LuCheck style={{ marginRight: 6 }} /> {saving ? 'Salvando…' : 'Salvar nova senha'}
        </button>
      </div>
    </div>
  );
}
